export enum InventoryAdjustmentForms {
  Update = 'UpdateInventoryAdjustments',
}
